<template>
<div>
    <div class="action-button">
        <div @click="showModal" class="btn btn-primary">
            <i class="fa fa-plus"></i> {{ $label('operator.create_invoice_prefix') }}&nbsp;</span>
        </div>
    </div>

    <div id="create-invoice-prefix-modal" class="modal fade" data-keyboard="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <div @click="closeModal" class="close">&times;</div>
                    <h4 class="modal-title">Modal Header</h4>
                </div>
                <div class="modal-body">
                    <div class="v-form v-borderless v-shadowless">
                        <div class="row">
                            <!-- BEGIN Invoice prefix name -->
                            <section class="col col-12">
                                <label class="label">{{ $label('operator.invoice_prefix_name_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.name"
                                        v-on:keyup.enter="createInvoicePrefix"
                                        :class="{ 'text-input-error': hasError('name') }"
                                        :placeholder="$label('operator.invoice_prefix_name_placeholder')"
                                        type="text"
                                    />
                                </label>

                                <p v-if="hasError('name')" class="text-danger">{{ getError('name') }}</p>
                            </section>
                            <!-- END Invoice prefix name -->
                        </div>

                        <div class="row">
                            <!-- BEGIN Invoice prefix from -->
                            <section class="col col-6">
                                <label class="label">{{ $label('operator.invoice_prefix_from_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.from"
                                        v-on:keyup.enter="createInvoicePrefix"
                                        :class="{ 'text-input-error': hasError('from') }"
                                        :placeholder="$label('operator.invoice_prefix_from_placeholder')"
                                        type="text"
                                    />
                                </label>

                                <p v-if="hasError('from')" class="text-danger">{{ getError('from') }}</p>
                            </section>
                            <!-- END Invoice prefix from -->

                            <!-- BEGIN Invoice prefix until -->
                            <section class="col col-6">
                                <label class="label">{{ $label('operator.invoice_prefix_until_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.until"
                                        v-on:keyup.enter="createInvoicePrefix"
                                        :class="{ 'text-input-error': hasError('until') }"
                                        :placeholder="$label('operator.invoice_prefix_until_placeholder')"
                                        type="text"
                                    />
                                </label>

                                <p v-if="hasError('until')" class="text-danger">{{ getError('until') }}</p>
                            </section>
                            <!-- END Invoice prefix until -->
                        </div>

                        <div class="row">
                            <!-- BEGIN Invoice prefix -->
                            <section class="col col-6">
                                <label class="label">{{ $label('operator.invoice_prefix_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.prefix"
                                        v-on:keyup.enter="createInvoicePrefix"
                                        :class="{ 'text-input-error': hasError('prefix') }"
                                        :placeholder="$label('operator.invoice_prefix_placeholder')"
                                        type="text"
                                    />
                                </label>

                                <p v-if="hasError('prefix')" class="text-danger">{{ getError('prefix') }}</p>
                            </section>
                            <!-- END END Invoice prefix -->

                            <!-- BEGIN Invoice export mark -->
                            <section class="col col-6">
                                <label class="label">{{ $label('operator.invoice_export_marker_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.export_marker"
                                        v-on:keyup.enter="createInvoicePrefix"
                                        :class="{ 'text-input-error': hasError('export_marker') }"
                                        :placeholder="$label('operator.invoice_export_marker_placeholder')"
                                        type="text"
                                    />
                                </label>

                                <p v-if="hasError('export_marker')" class="text-danger">{{ getError('export_marker') }}</p>
                            </section>
                            <!-- END Invoice export mark -->
                        </div>

                        <div class="row">
                            <!-- BEGIN Invoice start number -->
                            <section class="col col-4">
                                <label class="label">{{ $label('operator.invoice_start_number_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.start_number"
                                        v-on:keyup.enter="createInvoicePrefix"
                                        :class="{ 'text-input-error': hasError('start_number') }"
                                        :placeholder="$label('operator.invoice_start_number_placeholder')"
                                        type="text"
                                    />
                                </label>

                                <p v-if="hasError('start_number')" class="text-danger">{{ getError('start_number') }}</p>
                            </section>
                            <!-- END Invoice start number -->

                            <!-- BEGIN Invoice end number -->
                            <section class="col col-4">
                                <label class="label">{{ $label('operator.invoice_end_number_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.end_number"
                                        v-on:keyup.enter="createInvoicePrefix"
                                        :class="{ 'text-input-error': hasError('end_number') }"
                                        :placeholder="$label('operator.invoice_end_number_placeholder')"
                                        type="text"
                                    />
                                </label>

                                <p v-if="hasError('end_number')" class="text-danger">{{ getError('end_number') }}</p>
                            </section>
                            <!-- END Invoice end number -->

                            <!-- BEGIN Invoice next number -->
                            <!-- <section class="col col-3">
                                <label class="label">{{ $label('operator.invoice_next_number_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.next_number" type="text" :placeholder="$label('operator.invoice_next_number_placeholder')">
                                </label>
                            </section> -->
                            <!-- END Invoice next number -->

                            <!-- BEGIN Invoice increment step -->
                            <section class="col col-4">
                                <label class="label">{{ $label('operator.invoice_increment_step_label') }}</label>
                                <label class="input">
                                    <input v-model="inputs.increment_step"
                                        v-on:keyup.enter="createInvoicePrefix"
                                        :class="{ 'text-input-error': hasError('increment_step') }"
                                        :placeholder="$label('operator.invoice_increment_step_placeholder')"
                                        type="text"
                                    />
                                </label>

                                <p v-if="hasError('increment_step')" class="text-danger">{{ getError('increment_step') }}</p>
                            </section>
                            <!-- END Invoice increment step -->
                        </div>

                    </div>
                </div>
                <div class="modal-footer">
                    <div @click="createInvoicePrefix" :class="{ 'is-disabled': this.creatingInvoicePrefix }" class="btn btn-primary">{{ $label('common.create') }}</div>
                    <div @click="closeModal" class="btn btn-default">{{ $label('common.close') }}</div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import Api from '@/api';
import swal from 'sweetalert';
import FormErrorsMixin from '@/mixins/FormErrors.js';

export default {
    props: ['operatorId'],

    mixins: [FormErrorsMixin],

    data() {
        return {
            creatingInvoicePrefix: false,
            validatedInputs: [
                'name', 'from', 'until', 'prefix', 'export_marker',
                'start_number', 'end_number', 'increment_step',
            ],
            inputs: {
                name: '',
                from: '',
                until: '',
                prefix: '',
                export_marker: '',
                start_number: 1,
                end_number: '',
                increment_step: 1,
            }
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        showModal() {
            $('#create-invoice-prefix-modal').modal('show');
        },

        closeModal() {
            $('#create-invoice-prefix-modal').modal('hide');
            $('body').removeClass('modal-open');
            $('.modal-backdrop').remove();
        },

        createInvoicePrefix() {
            if (this.creatingInvoicePrefix) {
                return;
            }

            this.creatingInvoicePrefix = true;

            let endpoint = 'partners/demo_partner/operators/' + this.operatorId + '/invoice-prefixes';

            Api().post(endpoint, this.inputs)
                .then((success) => {
                    Event.$emit('refreshInvoicePrefixes', () => {
                        this.closeModal();
                        swal({
                            icon: 'success',
                            title: 'Invoice prefix created!',
                            text: 'The invoice prefix was created.',
                            buttons: false,
                            timer: 3000,
                        });
                    });
                })
                .catch((error) => {
                    this.storeErrors(error.response.data.errors);
                })
                .finally(() => {
                    this.creatingInvoicePrefix = false;
                });
        },

        resetInputs() {
            this.inputs = {
                name: '',
                from: '',
                until: '',
                prefix: '',
                export_marker: '',
                start_number: 1,
                end_number: '',
                increment_step: 1,
            }
        },

        listenEvents() {
            let vm = this;

            $('#create-invoice-prefix-modal').on('hide.bs.modal', function (e) {
                if (vm.creatingInvoicePrefix) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    return false;
                }
            });

            $('#create-invoice-prefix-modal').on('hidden.bs.modal', function () {
                vm.resetInputs();
                vm.resetErrors();
            });
        },
    },
}
</script>
